import {variables as apiVariables} from '@/environment/api';

import {useAuthQuery} from '@/features/auth/hooks/use-auth-query';
import {EventsQueryParameters, EventsResponse} from '../types/events';

// Query keys for cache invalidation
export const queryKeys = {
  userEvents: ['user-events'],
};

// Get the API base URL from environment variables
const getApiBaseUrl = () => apiVariables.RPC_BASE_URL.value;

/**
 * Hook to fetch user events
 *
 * @param eventParameters - Query parameters for filtering events
 * @param options - Additional options for the query
 * @returns Query result with events data
 */
export const useUserEventsQuery = (eventParameters: EventsQueryParameters = {}, options = {}) => {
  // Build query string from parameters
  const queryParameters = new URLSearchParams();
  if (eventParameters.limit) queryParameters.append('limit', eventParameters.limit.toString());
  if (eventParameters.offset) queryParameters.append('offset', eventParameters.offset.toString());
  if (eventParameters.event_types)
    queryParameters.append('event_types', eventParameters.event_types);
  if (eventParameters.from_time) queryParameters.append('from_time', eventParameters.from_time);
  if (eventParameters.to_time) queryParameters.append('to_time', eventParameters.to_time);

  const queryString = queryParameters.toString() ? `?${queryParameters.toString()}` : '';

  return useAuthQuery<EventsResponse>(
    [...queryKeys.userEvents, eventParameters],
    (token) =>
      fetch(`${getApiBaseUrl()}/api/events/user${queryString}`, {
        headers: {Authorization: `Bearer ${token}`},
      }).then((response) => {
        if (!response.ok) {
          throw new Error(`Failed to fetch events: ${response.status} ${response.statusText}`);
        }

        return response.json();
      }),
    options,
  );
};
